// @flow
import * as React from 'react';
import ErrorSection from 'components/ErrorSection';
import CenteredLayout from '../layouts/CenteredLayout';
import { setDocumentTitle } from '../utils/meta';

type Props = {
  error: Object
}; // error saved to redux by async code

export default class ErrorPage extends React.PureComponent<Props> {
  componentDidMount() {
    setDocumentTitle(getText('Something Went Wrong'));
  }

  render() {
    return (
      <CenteredLayout>
        <ErrorSection error={this.props.error} />
      </CenteredLayout>
    );
  }
}
